import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import Heroheader from "./sections/Heroheader";
import OurJourney from "./sections/OurJourney";
import Members from "./sections/Members";
import Brandedlogoshowcase from "./sections/Brandedlogoshowcase";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <Brandedlogoshowcase />
      <Heroheader />
      <OurJourney />
      <Members />
      <Footer />
    </div>;
}